import { z } from 'zod';

export const AcademicTitleSchema = z.object({
  idAcademicTitle: z.number().int(),
  AcademicTitle: z.string(),
});

export type IAcademicTitle = z.infer<typeof AcademicTitleSchema>;
